/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Backup_Llm_NoneInputs */



/**
* | output |
* | --- |
* | "None" |
*
* @param {Ad_Backup_Llm_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_backup_llm_none = /** @type {((inputs?: Ad_Backup_Llm_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Backup_Llm_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keiner")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Никто")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ninguno")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有任何")
	if (locale === "ja") return /** @type {LocalizedString} */ ("なし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum")
	return /** @type {LocalizedString} */ ("None")
});